export default __webpack_public_path__ + "static/FSCS-logo-10571141cca8422aec7cfa03cdbcc42a.svg";